import React, { useState } from 'react';
import classes from './index.module.scss';
import { Link, useHistory } from 'react-router-dom';
import { feedbackReportsDelete, messageDelete } from '../../api';
import DeleteReport from '../FeedbackReports/DeleteReport';

const MessageOptions = ({ id, type, setReplyBoxVisibility, handleDefaultStatusCodes, setLoading }) => {
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  }

  const link = type === 'message' &&  '/inbox' || type === 'feedback' && '/user-feedback'; 

  const deleteMessage = () => {
    switch (type) {
      case 'feedback':
        feedbackRequest()
        break;
      case 'message':
        messageRequest()
        break;
      default:
        setLoading(false);
    }
  }

  const feedbackRequest = () => {
    setLoading(true);
    feedbackReportsDelete({feedback_id: id})
      .then(response => {
        setLoading(false);
        history.push(link);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  const messageRequest = () => {
    setLoading(true);
    messageDelete({message_id: id})
      .then(response => {
        setLoading(false);
        history.push(link);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  const replyMessage = () => {
    setReplyBoxVisibility(true);
  }

  return (
    <div className={classes.Message_Footer}>
      <div>
        <button
          className="btnSizes filledBtn"
          onClick={replyMessage}
        >
          Reply
        </button>
        <Link
          to={link}
          className="btnSizes transparentBtn border-0 ml-5"
        >
          Cancel
        </Link>
      </div>
      <button
        className="btnSizes transparentBtn border-0"
        onClick={deleteMessage}
      >
        Delete Message
      </button>
      { showDeleteModal && <DeleteReport id={id} closeDeleteModal={closeDeleteModal} showDelete={showDeleteModal}/> }
    </div>
  )
}

export default MessageOptions;